import { GroundingSourceDTO } from "@shaarp/common";

/** Validates that a source has a valid URL. */
export const isValidSource = (source: GroundingSourceDTO): boolean => {
  try {
    new URL(source.url);
    return true;
  } catch {
    return false;
  }
};
